import { Button } from '@/components/ui/button';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

type ImageFormProps = {
  onSubmit: (data: any) => void;
  mutation: any;
};

export function ImageForm({ onSubmit, mutation }: ImageFormProps) {
  const navigate = useNavigate();

  const form = useForm({
    defaultValues: {
      name: '',
      file: null,
    },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
        <FormField
          control={form.control}
          name="name"
          render={({ field, fieldState }) => (
            <FormItem>
              <FormLabel>Name</FormLabel>
              <FormControl>
                <Input
                  autoComplete="off"
                  inError={!!form.formState.errors.name}
                  placeholder="Enter image name"
                  {...field}
                />
              </FormControl>
              <FormMessage>{fieldState.error?.message || ' '}</FormMessage>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="file"
          render={({ field, fieldState }) => (
            <FormItem>
              <FormLabel>Upload Image</FormLabel>
              <FormControl>
                <Input
                  type="file"
                  accept="image/*"
                  onChange={(e) => field.onChange(e.target.files?.[0])}
                  inError={!!form.formState.errors.file}
                />
              </FormControl>
              <FormMessage>{fieldState.error?.message || ' '}</FormMessage>
            </FormItem>
          )}
        />
        <div className="flex gap-4 justify-end">
          <Button
            type="button"
            variant="outline"
            onClick={() => navigate('/images')}
          >
            Cancel
          </Button>
          <Button type="submit" disabled={mutation.isPending}>
            {mutation.isPending ? 'Creating...' : 'Create image'}
          </Button>
        </div>
      </form>
    </Form>
  );
}
